import "../assets/styles/styles.scss";
import "./portfolio.scss";
